import VerifyResetCode from "../../components/Auth/VerifyResetCode";
function VerifyResetCodePage() {
    return <VerifyResetCode />;
}
export default VerifyResetCodePage;